// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './Pages/Home';

import Header from './Components/Header';
import FetchSubscriptions from './Components/FetchSubscriptions';

function App() {
  return (
    <Router>
      <div>
      <Header />

      <div className='content'>          
      {/* <h3 className='tx-center'>Welcome! TJD STOCK Management</h3> */}
        <Routes>



          <Route path="/FetchSubscriptions" element={<FetchSubscriptions />} />          

        </Routes>
        </div>
        
      </div>
    </Router>

  );
}

export default App;
